import Api from './Api';

export default {
	addToFavorites(id) {
		return Api.get('add_to_favorites?id=' + id);
	},
	removeFromFavorites(id) {
		return Api.get('remove_from_favorites?id=' + id);
	},
	getList() {
		return Api.get('get_list');
	},
	createWishlist(data) {
		return Api.post('create_wishlist', data);
	},
	getWishlist() {
		return Api.get('get_whishlist');
	},
	addToWishlist(obj) {
		return Api.post('add_to_wishlist', obj);
	},
	removeFromWishlist(obj) {
		return Api.post('remove_from_wishlist', obj);
	},
	createWishlistNoProduct(title) {
		return Api.get('create_wishlist_no_product?title=' + title);
	},
	getRecommendations() {
		return Api.get('get_recommendations');
	},
	getViewed() {
		return Api.get('get_viewed');
	},
};
